import { Body, Heading, Link } from '@hover/blueprint';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { TRUST_CENTER_SECURITY_AND_PRIVACY } from '../../constants';
import { SharedFaq } from '../common';

const SecurityAndPrivacy: React.FC = () => (
  <>
    <Heading as="h2" size={500} mt="56px">
      Security and Privacy
    </Heading>
    <Body mb={500}>
      We train our employees on our security and privacy policies. Our policies
      govern acceptable and prohibited use of our networks and services. More
      importantly, they describe how we protect your personal data. You can
      review how we protect your privacy{' '}
      <Link as={GatsbyLink} to="/privacy/" fontWeight={400}>
        here
      </Link>
      .
    </Body>
    <Body mb={600}>Some of our most important policies include:</Body>
    <SharedFaq questions={TRUST_CENTER_SECURITY_AND_PRIVACY} />
  </>
);

export default SecurityAndPrivacy;
